export default "__VITE_PUBLIC_ASSET__a0b3ed80__"